import * as Money from 'ezmoney';

import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

import { type TransferQuote } from '../../hooks';

type InlineQuoteProps = {
  quote?: TransferQuote;
};

export const InlineQuoteAmount = ({ quote }: InlineQuoteProps) => {
  if (!quote?.paymentOptions?.length) {
    return null;
  }
  if (quote.targetCurrency === quote.sourceCurrency) {
    return null;
  }

  const defaultPaymentOption = quote.paymentOptions[0];
  const amount =
    defaultPaymentOption.sourceAmount - defaultPaymentOption.fees.partner;

  return (
    <>
      <p className="text-14 font-medium text-content-secondary-bg-primary">
        {formatMonetaryValue(Money.fromNumber(amount, quote.sourceCurrency, 2))}
      </p>
      <div className="h-[4px] w-[4px] rounded-4 bg-background-tertiary-default" />
    </>
  );
};
